import axios from 'axios'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { initReactI18next } from 'react-i18next'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { store } from './api/store'
import App from './App'
import Loading from './components/other/Loading'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { getBackendLanguage, LANGUAGE_STORAGE_KEY, toHtmlLang } from './utils/language'

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = toHtmlLang(lng)
})

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ['en', 'bos'],
    fallbackLng: 'bos',
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    backend: {
      loadPath: '/assets/locales/{{lng}}/translation.json',
    },
  })

axios.interceptors.request.use((config) => {
  config.headers['Accept-Language'] = getBackendLanguage(i18n)
  return config
})

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  </Suspense>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
